import {Component, OnInit} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommandResponse} from '@shared/commands/command-base';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {take} from 'rxjs/operators';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CompanyModel} from '@features/admin-panel/models/company.model';
import {isNullOrEmptyString} from '@progress/kendo-data-query/dist/npm/utils';
import {Field, FieldSelectionViewModel} from '@features/file-manager/component/select-fields-dialog/select-fields-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {SnackBarService} from '@core/services/snack-bar.service';
import _ from 'lodash';


@Component({
    standalone: false,
    selector: 'app-map-company',
  templateUrl: './map-company.component.html',
  styleUrls: ['./map-company.component.scss']
})
export class MapCompanyComponent implements OnInit, IPlatformToolComponent {
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  addMappingForm: FormGroup;
  destinationCompanyId: string;
  makeVisibleRest: boolean;
  sourceType = 'MapCompany';
  tempCompanies: Array<CompanyModel>;
  companies: Array<CompanyModel>;
  selectedCompanies: string[];
  mapCompaniesString: string;

  constructor(private formBuilder: FormBuilder,
              private platformQueryService: PlatformQueryService,
              private dialogService: DialogService,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService) {
  }

  ngOnInit(): void {
    const platformQuery = new PlatformQuery();
    platformQuery.name = 'GetAllCompanyQuery';
    platformQuery.api = Api.AdminPanel;
    this.fuseSplashScreenService.show();
    this.platformQueryService.executeQuery(platformQuery).pipe(take(1)).subscribe(response => {
      this.fuseSplashScreenService.hide();
      if (response.fieldValues['DataItems']) {
        this.companies = response.fieldValues['DataItems'];
      } else {
        console.log('GetAllCompanyQuery failed to fetch DataItems in MapCompanyComponent!');
      }
    });
    this.addMappingForm = this.formBuilder.group({
      destinationCompany: ['', Validators.required],
      mappedCompanies: ['', Validators.required]
    });
    this.addMappingForm.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    });
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }

  onClickMappedCompanies() {
    const dialogModel = DialogModel.create(
      'Select Mapped Companies',
      'SelectCompaniesDialogComponent',
      {companies: this.tempCompanies}
      );
    dialogModel.isDisabledOkButton = true;
    dialogModel.maxWidth = '800px';
    dialogModel.minWidth = '800px';
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(actionState => {
      if (actionState.action === 'OK' && actionState.data.input.onSelectedCompanies) {
        let mapCompaniesString = '';
        actionState.data.input.onSelectedCompanies.forEach(companyId => {
          mapCompaniesString = mapCompaniesString + companyId + ',\n';
        });
        this.mapCompaniesString = mapCompaniesString.slice(0, -2);
        this.selectedCompanies = actionState.data.input.onSelectedCompanies;
        this.addMappingForm.controls.mappedCompanies.disable({onlySelf: true, emitEvent: true});
        if (this.selectedCompanies.length >= 2 && this.selectedCompanies.length <= 10 && this.destinationCompanyId) {
          this.enableDoneButton();
        }
      }
    });
  }

  private enableDoneButton() {
    const command = this.handler.magicLinkModel.breadcrumbBar.items.find(o => o.id === 'Default').commands.find(c => c.title === 'Done');
    command.isDisabled = false;
    command.fieldValues['DestinationCompanyId'] = this.destinationCompanyId;
    command.fieldValues['MappedCompanies'] = this.selectedCompanies;
  }

  private onFormValuesChanged() {
    if (this.addMappingForm.value.destinationCompany) {
      if (this.addMappingForm.value.destinationCompany !== this.destinationCompanyId) {
        this.addMappingForm.controls.mappedCompanies.enable({onlySelf: true, emitEvent: true});
        this.destinationCompanyId = this.addMappingForm.value.destinationCompany;
      }
      this.tempCompanies = _.clone(this.companies);
      this.tempCompanies.forEach(company => {
        if (company.companyId === this.destinationCompanyId) {
          this.tempCompanies.splice(this.tempCompanies.indexOf(company), 1);
        }
      });
      this.makeVisibleRest = true;
    }
  }
}
